export const EMBEDDED_SOURCE_PRODUCTS = {
	GoogleDrive: 'GoogleDrive',
	Loom: 'Loom',
	Google: 'Google',
};
